import React from 'react';
import { useDisclosure } from '@withjoy/joykit';

import CurrencySelectorModal, { CurrencySelectorTrigger } from './CurrencySelectorModal';
import type { SupportedCurrency } from '@shared/utils/currency';

type CurrencySelectorProps = Readonly<{
  isEnabled: boolean;
  supportedCurrencies?: ReadonlyArray<SupportedCurrency & { name: string }>;
}>;

export const CurrencySelector: React.FC<CurrencySelectorProps> = ({ isEnabled, supportedCurrencies }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!isEnabled) return null;

  const handleTriggerClick = () => {
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  };

  return (
    <CurrencySelectorModal
      isOpen={isOpen}
      onClose={onClose}
      supportedCurrencies={supportedCurrencies}
      trigger={
        <CurrencySelectorTrigger
          isOpen={isOpen}
          onClick={handleTriggerClick}
        />
      }
    />
  );
};
